import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "grommet";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const NavigateToPath = ({ path }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    return <> {pathname != path && <Button icon={<FontAwesomeIcon size="lg" icon={["fad", "up-right-and-down-left-from-center"]}></FontAwesomeIcon>} onClick={() => navigate(path)}></Button>}</>;
};

export default NavigateToPath;
